import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { CubiqWorker } from "../../../worker/CubiqWorker";
import { IBlotterDefinitionLookupService } from "../IBlotterDefinitionLookupService";
import { LoggerService } from "@bfx/logger";
import { NullProtoObject } from "../../../../helper-services/null-proto-object";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BlotterDefinitionLookupService
  extends BaseLookupService<string, CubiqTS.BlotterDefinitionImpl>
  implements IBlotterDefinitionLookupService
{
  // Name is unique on non-deleted blotters
  private blotterNameMap: NullProtoObject<CubiqTS.BlotterDefinitionImpl> = Object.create(null);

  constructor() {
    super(CubiqTS.BlotterDefinitionImpl);
  }

  getBlotterDefinition(code: string): CubiqTS.BlotterDefinitionImpl {
    return this.blotterNameMap[code];
  }

  getItem(key: string): CubiqTS.BlotterDefinitionImpl {
    return key ? this.myItemMap.get(key) : null;
  }

  getItemKey(item: CubiqTS.BlotterDefinitionImpl): string {
    return item.blotterId.toString();
  }

  mapItem(item: CubiqTS.BlotterDefinitionImpl): void {
    if (this.myItemMap.has(item.blotterId.toString())) {
      let oldItem = this.getItem(item.blotterId.toString());
      this.deleteItem(oldItem);
    }

    this.myItemMap.set(item.blotterId.toString(), item);
    this.blotterNameMap[item.blotterName] = item;
  }

  deleteItem(item: CubiqTS.BlotterDefinitionImpl): void {
    item = this.blotterNameMap[item.blotterName];
    this.myItemMap.delete(item.blotterId.toString());
  }

  getMyBlotterDefinitions(currentUserId: string): Array<CubiqTS.BlotterDefinitionImpl> {
    let blotterDefinitions: Array<CubiqTS.BlotterDefinitionImpl> =
      new Array<CubiqTS.BlotterDefinitionImpl>();
    return this.getAll().filter(
      (blotter: CubiqTS.BlotterDefinitionImpl) => blotter.entryUserId.toString() == currentUserId,
    );
  }
}
